import { NgModule } from '@angular/core';
import { ErzeugungsanlagePageComponent } from './erzeugungsanlage-page/erzeugungsanlage-page.component';
import { RouterModule, Routes } from '@angular/router';
import { ErzeugungsanlageDetailComponent } from './erzeugungsanlage-detail/erzeugungsanlage-detail.component';

export const erzeugungsanlageRoutes: Routes = [
    {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
    },
    {   // lists all Erzeugungsanlagen
        path: 'list',
        component: ErzeugungsanlagePageComponent,
    },
    {   // shows the details of an Erzeugungsanlage
        path: 'detail/:dokumentenId',
        component: ErzeugungsanlageDetailComponent,
    },
];

@NgModule({
    imports: [
        RouterModule.forChild(erzeugungsanlageRoutes),
    ],
    exports: [
        RouterModule,
    ],
})
export class ErzeugungsanlageRoutingModule {
}
